import CountryPackage from "country-list-with-dial-code-and-flag";
import { useRef, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  UncontrolledDropdown,
} from "reactstrap";
import Flag from "react-world-flags";
import { PiCaretDownLight } from "react-icons/pi";
import NormalInput2 from "./NormalInput2";

const CountrySelectInput = ({
  value,
  setValue,
  setValueFullNameSelect,
  placeholder,
  style,
  className,
  adaptStyle,
  showCaret,
  label,
  countryFullName,
}) => {
  const allCountriesRef = useRef(CountryPackage.getAll());
  const [searchedResults, setSearchedResults] = useState([]);

  const handleSearch = (value) => {
    if (value !== "") {
      let array = [...allCountriesRef?.current]?.filter((c) =>
        c?.name?.toUpperCase()?.includes(value?.toUpperCase())
      );
      setSearchedResults(array);
    } else setSearchedResults([]);
  };

  const formateValue = () => {
    let country = [...allCountriesRef?.current]?.find((c) => (c?.code??c?.name) === (value?.code??value?.name??value));
    if (country)
      return (
        <div className="d-flex align-items-center full-width gap-2">
          <Flag
            code={country?.code}
            className="object-fit-cover"
            height={adaptStyle?.iconSize ?? 40}
            width={adaptStyle?.iconSize ?? 40}
            style={{ borderRadius: "50%" }}
          />
          <small className="f-5 text-black">{country?.name}</small>
        </div>
      );
    else return "";
  };

  return (
    <div>
      {label && <Label className="figma-input-label">{label}</Label>}
      <UncontrolledDropdown className="normal-input-2">
        <DropdownToggle
          style={style}
          className={`   f-4 py-2 px-3 border-none text-black full-width ${className} d-flex justify-content-between align-items-center`}
        >
          {value ? formateValue() : placeholder}
          {showCaret && (
            <div className="color-primary-black-2">
              <PiCaretDownLight size={25} />
            </div>
          )}
        </DropdownToggle>
        <DropdownMenu className="full-width">
          <div className=" outer-transparent-shadow">
            <NormalInput2
              placeholder={"Search here"}
              style={{ borderRadius: 0 }}
              setValue={(v) => handleSearch(v)}
              className={"bg-transparent full-width br-0 border-none"}
            />
          </div>
          <div
            className=""
            style={{
              height: "300px",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            {searchedResults?.length === 0
              ? allCountriesRef?.current?.map((c) => (
                  <DropdownItem
                    tag={"div"}
                    onClick={() => {
                      setValue(c?.name);
                      setValueFullNameSelect(c?.name);
                    }}
                    className="d-flex p-2 cursor-pointer br-0 justify-content-start"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <Flag
                        style={{
                          borderRadius: "50%",
                          objectFit: "cover",
                          aspectRatio: 1,
                        }}
                        code={c?.code}
                        height={40}
                        width={40}
                      />
                      <small className="f-5 ">{c?.name}</small>
                    </div>
                  </DropdownItem>
                ))
              : searchedResults?.map((c) => (
                  <DropdownItem
                    tag={"div"}
                    onClick={() => {
                      setValue(c?.code);
                      setValueFullNameSelect(c?.name);
                    }}
                    className="d-flex cursor-pointer br-0 p-2 justify-content-start"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <Flag
                        style={{
                          borderRadius: "50%",
                          objectFit: "cover",
                          aspectRatio: 1,
                        }}
                        code={c?.code}
                        height={40}
                        width={40}
                      />
                      <small className="f-5 ">{c?.name}</small>
                    </div>
                  </DropdownItem>
                ))}
          </div>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default CountrySelectInput;
